<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <div *ngIf="noteType === 'customer'; else adminTitle">
        {{ 'COMMON.ORDER_DETAILS.CUSTOMER_NOTES_TITLE' | translate }}
      </div>
      <ng-template #adminTitle>
        {{ 'COMMON.ORDER_DETAILS.ADMINISTRATIVE_NOTES_TITLE' | translate }}
      </ng-template>
      <div class="update-spinner" *ngIf="updatingNotes">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <div class="edit-button" *ngIf="editingType === 'toggleable' && !updatingNotes">
        <button mat-button color="primary" *ngIf="!editMode" (click)="onClickEdit()">
          {{ 'COMMON.ORDERS.EDIT' | translate }}
        </button>
      </div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <glxy-form-field *ngIf="editMode">
      <textarea
        matInput
        #textFocus
        [formControl]="formControl"
        (blur)="onBlur()"
        placeholder="{{ 'COMMON.ORDER_DETAILS.EMPTY_NOTES' | translate }}"
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="10"
      ></textarea>
      @switch (noteType) {
        @case ('customer') {
          <glxy-hint>
            {{ 'COMMON.ORDER_DETAILS.CUSTOMER_NOTES_INFO' | translate }}
          </glxy-hint>
        }
        @case ('administrator') {
          <glxy-hint>
            {{ 'COMMON.ORDER_DETAILS.ADMINISTRATIVE_NOTES_INFO' | translate }}
          </glxy-hint>
        }
      }
    </glxy-form-field>

    <div *ngIf="!editMode">
      <div *ngIf="!!existingNotes; else noNotes" class="notes">
        {{ existingNotes }}
      </div>
      <ng-template #noNotes>
        <div class="no-notes">
          {{ 'COMMON.ORDER_DETAILS.EMPTY_NOTES' | translate }}
        </div>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>
